import React, { Component } from "react";

import { withTranslation } from "react-i18next";
import i18n from "i18next";
import FlagUa from "../../images/flag-ua.png";
import FlagRu from "../../images/flag-ru.png";

class Language extends Component {
    constructor(props) {
        super(props);
        
    }

    
  buttonLang = (lang, flagImg) => {
    return (
      <div
        className={
          i18n.language === lang
            ? "header-lang active"
            : "header-lang  non-active"
        }
        id={lang}
        onClick={() => {
          var regex = new RegExp("(?<=product?.\\/)(.*?)(?=\\/)", "m");
          var newLink =
            this.props.location.pathname + this.props.location.search;
          var replaced = newLink.replace(regex, lang);
          if (i18n.language !== lang) {
            window.location.href = replaced;
          }
        }}
        title={lang}
      >
        <img src={flagImg} alt={lang} />
      </div>
    );
  };
  render() {
    const { t } = this.props;
    return (
      <div className="lang-switcher">
        {this.buttonLang("ua", FlagUa)}
        {this.buttonLang("ru", FlagRu)}
      </div>
    );
  }
}

const LanguageSwitcher = withTranslation("translations")(Language);

export default LanguageSwitcher;
